import * as yup from 'yup'
import { AutocompleteValueSchemaObject } from '../../../AutocompleteValueSchema'
import { REQUIRED_MESSAGE } from '../../../constants'

export const ShipperFacilitySchemaObject = {
  /**
   * @example { id: 'ef6f8870-8676-4b91-95c2-85dd486263f3', text: 'Shipper Facility Label' }
   */
  shipperFacility: yup
    .object({
      ...AutocompleteValueSchemaObject,
      address: yup.string(),
      city: yup.string(),
      stateCode: yup.string(),
    })
    .nullable()
    .required(REQUIRED_MESSAGE),
}

export const ShipperFacilitySchema = yup.object(ShipperFacilitySchemaObject)

export type TShipperFacilitySchema = yup.InferType<typeof ShipperFacilitySchema>
